import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { CHECKOUT_MEGAPACK, CHECKOUT_MEGAPACK_KIT } from '../data/content';
const finalPlans = [{
  emoji: '📘',
  name: 'MegaPack Caligrafía y Lectoescritura',
  includes: '6 Tomos + 6 Bonos · Todos los niveles',
  oldPrice: '$51.000',
  price: '$19.990 ARS',
  cta: '→ Quiero mi MegaPack',
  href: CHECKOUT_MEGAPACK,
  featured: false
}, {
  emoji: '🏆',
  name: 'MegaPack + Kit Inclusión ⭐',
  includes: '6 Tomos + 6 Bonos + Kit Inclusión completo',
  oldPrice: '$69.000',
  price: '$27.990 ARS',
  cta: '→ Quiero el MegaPack + Kit Inclusión',
  href: CHECKOUT_MEGAPACK_KIT,
  featured: true
}];
export function FinalCta() {
  return <section id="comprar" aria-labelledby="cierre-titulo" className="w-full bg-navy-deep py-14 text-white sm:py-20" data-id="element-71" data-mp="223w72fnu5adi">
      <div className="mx-auto max-w-5xl px-5" data-id="element-72" data-mp="n5umo42k7rht">
        <h2 id="cierre-titulo" className="text-center font-display text-xl font-extrabold uppercase tracking-widest text-gold sm:text-2xl" data-id="element-73" data-mp="n75o3x8j8n5r">
          ⏰ El precio cierra en:
        </h2>

        <div className="mt-5" data-id="element-74" data-mp="x5v8bwnwijp6">
          <Countdown data-id="element-75" data-mp="122loejzphfal" />
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-76" data-mp="123mwcflfdlo3">
          {finalPlans.map(plan => <article key={plan.name} className={`flex flex-col rounded-3xl border-2 p-6 sm:p-7 ${plan.featured ? 'border-gold bg-white/10 shadow-pop' : 'border-white/20 bg-white/5'}`} data-id="element-77" data-mp="163p2b0y71196">
              <h3 className="font-display text-xl font-extrabold leading-tight" data-id="element-78" data-mp="1ks1nr3znn1pf">
                <span aria-hidden="true" data-id="element-79" data-mp="1pt8x37hg48y7">{plan.emoji} </span>
                {plan.name}
              </h3>
              <p className="mt-2 text-sm font-bold text-celeste-light" data-id="element-80" data-mp="1tv2un6wcgwu5">{plan.includes}</p>
              <p className="mt-5 text-base font-bold text-white/50 line-through" data-id="element-81" data-mp="3qtvymgub7aht">
                {plan.oldPrice}
              </p>
              <p className="font-display text-4xl font-extrabold leading-none text-gold sm:text-5xl" data-id="element-82" data-mp="3lx5jbvqbwixg">
                {plan.price}
              </p>
              <CtaButton href={plan.href} variant={plan.featured ? 'primary' : 'secondary'} className="mt-6 w-full text-center" data-id="element-83" data-mp="3uwit6pid79ip">
                {plan.cta}
              </CtaButton>
            </article>)}
        </div>

        <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/75 sm:text-sm" data-id="element-84" data-mp="mgh24pfdv4tm">
          <li className="inline-flex items-center gap-1.5" data-id="element-85" data-mp="ifx47jmzjx6f">
            <LockIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-86" data-mp="2o7tz8sb408f4" />
            Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-87" data-mp="2k6qqsqve5enx">
            <ZapIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-88" data-mp="2k8l9dyj6wuou" />
            Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-89" data-mp="2e3ngs7l080r1">
            <ShieldCheckIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-90" data-mp="2e33vcgw5au89" />
            Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-91" data-mp="25blhicmo8qic">
            <CreditCardIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-92" data-mp="25a0lsjomf1iw" />
            Mercado Pago | Tarjeta | Transferencia
          </li>
        </ul>
      </div>
    </section>;
}